<script>
import MainMenuView from '../../../shared/views/MainMenuView';
import ListEvaluationsView from '../lists/ListEvaluationsView';
import PermissionHelper from '../../../../core/shared/helpers/PermissionHelper';
import PageHeaderView from '../../../shared/views/PageHeaderView';

export default {
  components: {
    'page-header-view': PageHeaderView,
    'main-menu-view': MainMenuView,
    'list-evaluations-view': ListEvaluationsView,
  },
  data() {
    return {};
  },
  computed: {},
  methods: {
    onCanShow(moduleName) {
      return PermissionHelper.canShow(moduleName);
    },
  },
};
</script>
<template>
  <div>
    <main-menu-view />
    <div class="wrapper">
      <div class="sa4d25">
        <div class="container-fluid">
          <div class="row">
            <div class="col-xl-12 col-lg-12">
              <div class="section3125">
                <page-header-view
                  icon="fas fa-clipboard-check"
                  title="Evaluaciones"
                  subtitle="Exámenes, reactivos y resultados de las evaluaciones de la plataforma"
                />
                <div class="la5lo1">
                  <list-evaluations-view />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
